export default {
    buttons: {
        login: 'Prijava',
    },

    links: {
        forgot_password: 'Zaboravljena lozinka?',
    },

    fields: {
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
        password: {
            label: 'Lozinka',
            placeholder: '6 karaktera minimum',
        },
    },
}
